'use strict';

(function($) {
	
	
	var timeoutHolder;

	window[addEventListener? 'addEventListener' : 'attachEvent'](addEventListener? 'load' : 'onload', load);

	$(document).ready(function(){

		var sizeMenuBox = $('#box line').get(0).getTotalLength();
		$('#box line:nth-child(1), #box line:nth-child(2)').css('stroke-dashoffset', $('#main_nav .outer-wrapper').innerWidth()+8);
		$('#box line:nth-child(1), #box line:nth-child(2)').css('stroke-dasharray', $('#main_nav .outer-wrapper').innerWidth()+8);
		$('#box line:nth-child(3), #box line:nth-child(4)').css('stroke-dashoffset', $('#main_nav .outer-wrapper').innerHeight());
		$('#box line:nth-child(3), #box line:nth-child(4)').css('stroke-dasharray', $('#main_nav .outer-wrapper').innerHeight());

		$('.img-link').each(function(){
			var box = $(this).children('.box');
			if(box.length){
				if (box.children('rect').length) {
					var lineSize = box.children('rect').get(0).getTotalLength();
					box.css('stroke-dasharray', lineSize/24);
				}
			}
		});

/* 		$('#hamburger').click(function(){
			//$('#main_nav').addClass('active');
			console.log('clicked! hamburger')
		});
 */
/* 		$('#search').click(function(){
			var form = $('.search-form'),
				coords = form.offset(),
				coordsContainer = $('body>.container').offset(),
				movingBox = $('header .r6');
				console.log('clicked! search')

			if(!form.hasClass('shown')){
				var scale = 1900 / +$('body>.container').width(); // 1900 is original width of graphic, this provides scalability to rectagular

				scale = scale.toFixed(6);
				movingBox.css({
					x: (coords.left - coordsContainer.left - 10) * scale,
					// x: coords.left + (scale * 5),
					y: coords.top * scale,
					// width: (form.width())+'px',
					// height: (form.height())+'px',
					width: (scale*(form.width()+30)/16)+'rem',
					height: (scale*(form.height()+15)/16)+'rem',
					fill: '#465165',
					stroke: '#465165',
					// transform: 'scale('+scale+')',
					transition: '.5s',
					'stroke-dasharray': '0',
				});

				$('#search, #hamburger').addClass('go-up');
				form.addClass('shown');
				setTimeout(function(){
					$('.search-form input').focus();
				}, 500);
			} else {
				movingBox.css({
					x: '',
					y: '',
					width: '',
					height: '',
					fill: '',
					stroke: '',
					transform: '',
					'stroke-dasharray': '',
					transition: '.5s ease .25s',
				});
				$('#search, #hamburger').removeClass('go-up');
				form.removeClass('shown');
			}
		}); */

		/* $('#close').click(function(){
			$('#main_nav').removeClass('active');
		}); */

		if(window.innerWidth > 768) {
			$('#main_nav a').on('mouseover', function(e){
				var w = $(this).children().width();
				var t = $(this).offset().top - parseInt($('#main_nav').css('top'));

				$('#hover-box').width(w+13).css('top', t+"px").fadeIn(200);
			});

			$('#main_nav .wrapper').on('mouseleave', function(e){
				$('#hover-box').fadeOut(200);
			});
		}

		$('.collections-page .swiper-slide a').on('mouseover', function(e){
			e.preventDefault();
			var i = +$(this).attr('data-index');

			$('.featured-images img').removeClass('shown');
			$('.featured-images img').eq(i).addClass('shown');
		});

		if($('.biograms-page').length) {
			var mySwiper;

			$('.letter-box').click(function(){
				var namesBox = $(this).siblings();
				$('.letter-wrapper').removeClass('opened');
				$(this).parent().addClass('opened');
				new SimpleBar(namesBox.get(0), { autoHide: false });
				setTimeout(function(){
					mySwiper.update();
				}, 500);
			});

			setTimeout(function(){
				$('h1').addClass('shown');
				$('.letter-wrapper').addClass('shown');

				mySwiper = new Swiper('.swiper-container', {
					slideClass: 'letter-wrapper',
					wrapperClass: 'biograms-wrapper',
					freeMode: true,
					slidesPerView: 'auto',
					watchOverflow: true,
					on: {
						slideChangeTransitionStart: function(swiper){
							if(swiper.isBeginning){
								$('.biograms-control.go-left').addClass('hidden');
							} else {
								$('.biograms-control.go-left').removeClass('hidden');
							}
							if(swiper.isEnd){
								$('.biograms-control.go-right').addClass('hidden');
							} else {
								$('.biograms-control.go-right').removeClass('hidden');
							}
						}
					}
				});
			}, 1500);
			setTimeout(function(){
				$('.biograms-control').removeClass('hidden');
				$('.biograms-control').click(function(){
					if($(this).hasClass('go-left')){
						mySwiper.slidePrev();
					} else {
						mySwiper.slideNext();
					}
				});
			}, 6000);
		}

		if(typeof Swiper === 'function') {
			if($('.collections-page').length){
				var mySwiper = new Swiper('.swiper-container', {
					direction: 'vertical',
					slidesPerView: 5,
					watchSlidesVisibility: true,
					on: {
						slideChangeTransitionStart: function(swiper){
							var i = swiper.activeIndex;

							if(swiper.isBeginning){
								$('.collections-control.go-left').addClass('hidden');
							} else {
								$('.collections-control.go-left').removeClass('hidden');
							}
							if(swiper.isEnd){
								$('.collections-control.go-right').addClass('hidden');
							} else {
								$('.collections-control.go-right').removeClass('hidden');
							}

							$('.featured-images img').removeClass('shown');
							$('.featured-images img').eq(i).addClass('shown');
						}
					}
				});

				$('.collections-control').click(function(){
					if($(this).hasClass('go-left')){
						mySwiper.slidePrev();
					} else {
						mySwiper.slideNext();
					}
				});
			}
		}

		$(window).resize(function(){
			clearTimeout(timeoutHolder);
			timeoutHolder = setTimeout(function(){
				// 09.09.2022
				// if(window.innerWidth > 768) {
				// 	$('.biograms').prepend($('.biograms-photos'));
				// 	$('.photographs').append($('.photographs .img-wrapper'));
				// 	$('.documents .wrapper').prepend($('.documents-photos'));
				// } else {
				// 	$('.biograms .arrow-link').before($('.biograms-photos'));
				// 	$('.photographs .arrow-link').before($('.photographs .img-wrapper'));
				// 	$('.documents .arrow-link').before($('.documents-photos'));
				// }
			}, 200);
		});

		$(window).resize();
	});

	function load(){
		var img = $('.photographs .img-wrapper img'),
			w = img.width(),
			h = img.height();

		if($('.results-wrapper').length) {
			if(window.innerWidth > 768){
				var lastRight = 0;
				var rows = 0;
				var bodyP = $('body>.container').offset().left;

				$('.results-wrapper img').each(function(i){
					var top  = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
					left = $(this).offset().left - bodyP,
					w    = $(this).width(),
					h    = $(this).height(),
					mBW  = 200; // max box width

					if(lastRight != 0){
						lastRight += (Math.random()*20)+10;
						var boxSize = left-lastRight-(Math.random()*30)-10;
					} else {
						var boxSize = left-(Math.random()*40)-5;
					}

					if(boxSize > mBW){
						var boxCount = Math.ceil(boxSize/mBW), gutter; // next box gutter

						for(var i = 0; i < boxCount; i++){
							var boxSizePart = mBW-(Math.random()*30)-10;

							if(boxSize>boxSizePart){
								gutter = (Math.random()*30)+5;
								boxSize -= boxSizePart + gutter;
							} else {
								boxSizePart = boxSize;
							}

							$('.box-wrapper').append('<div class="box"></div>');
							$('.box-wrapper>.box').last().css({
								top: top,
								left: lastRight,
								width: boxSizePart,
								height: h,
							});

							lastRight += boxSizePart + gutter;
						}
					} else {
						$('.box-wrapper').append('<div class="box"></div>');
						$('.box-wrapper>.box').last().css({
							top: top,
							left: lastRight,
							width: boxSize,
							height: h,
						});
					}

					if(i%3 == 0){
						rows++;
					};

					lastRight = i%3 == 2? 0 : left+w;
				});

				for(var row = 0; row<rows; row++){ // rects most on right
					var item = $('.results-wrapper img').eq(row*3+2);

					if(!item.length) {
						item = $('.results-wrapper img').last();
					}

					var top  = item.offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
					left = item.offset().left - bodyP,
					w    = item.width(),
					h    = item.height(),
					position = left+w+(Math.random()*20)+10;

					$('.last-column').append('<div class="box"></div>');
					$('.last-column>.box').last().css({
						top: top,
						left: position,
						width: window.innerWidth - position - 15,
						height: h,
					});
				}
			} else {
				$('.results-wrapper img').each(function(i){
					var top  = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight(),
					left = $(this).offset().left,
					w    = $(this).width(),
					h    = $(this).height(),
					randomFactor = window.innerWidth > 480 ? Math.random()*20 : Math.random()*5;

					var boxSize = left - randomFactor - 5;

					$('.box-wrapper').append('<div class="box"></div>');
					$('.box-wrapper>.box').last().css({
						top: top,
						left: 0,
						width: boxSize,
						height: h,
					});

					var randomFactor = window.innerWidth > 480 ? Math.random()*20 : Math.random()*5,
						boxSize = window.innerWidth - left - w - randomFactor - 5;

					$('.last-column').append('<div class="box"></div>');
					$('.last-column>.box').last().css({
						top: top,
						width: boxSize,
						height: h,
					});
				});
			}
		}

		if($('.single-biogram').length && window.innerWidth > 768) {
			var bodyP = $('body>.container').offset().left;
			var lastRight = 0;

			$('.related-item img').each(function(i){
				var top  = $(this).offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight() - $('.col-2').innerHeight(),
					left = $(this).offset().left - bodyP,
					w    = $(this).width(),
					h    = $(this).height(),
					mBW  = 200; // max box width

				if(lastRight != 0){
					lastRight += (Math.random()*20)+10;
					var boxSize = left-lastRight-(Math.random()*30);

					if(i==1) boxSize -= 15;
				} else {
					var boxSize = left-(Math.random()*30)-5;
				}

				if(boxSize > mBW){
					var boxCount = Math.ceil(boxSize/mBW);

					for(var i = 0; i < boxCount; i++){
						var boxSizePart = mBW-(Math.random()*30)-10,
							gutter; // next box gutter

						if(boxSize>boxSizePart){
							boxSize -= boxSizePart;
							gutter = (Math.random()*15)+10;
						} else {
							boxSizePart = boxSize - gutter;
							gutter = 0;
						}

						$('.box-wrapper').append('<div class="box"></div>');
						$('.box-wrapper>.box').last().css({
							top: top,
							left: lastRight,
							width: boxSizePart,
							height: h,
						});

						lastRight += boxSizePart + gutter;
					}
				} else {
					$('.box-wrapper').append('<div class="box"></div>');
					$('.box-wrapper>.box').last().css({
						top: top,
						left: lastRight,
						width: boxSize,
						height: h,
					});
				}
				lastRight = left+w;
			});

			var item = $('.related-item img').eq(2);
			var top  = item.offset().top - $('#mainheader').innerHeight() - $('#bc').innerHeight() - $('.col-2').innerHeight(),
				left = item.offset().left - bodyP,
				w    = item.width(),
				h    = item.height();

			$('.box-wrapper').append('<div class="box"></div>');
			$('.box-wrapper>.box').last().css({
				top: top,
				left: 'auto',
				right: 0,
				width: w-(Math.random()*10)-60,
				height: h,
			});
		}
	}
})(jQuery);

function typeAnimation(text, callback){
	var string = text, j = 0,
		intervalHolder = setInterval(function(){
			$('.type-animation').text(string.substring(0, j++));
			if(j > string.length){
				clearInterval(intervalHolder);
				if(typeof callback == 'function') callback();
			}
		}, 50);
}

function setCookie(cname, cvalue, exdays, path) {
	path = path || "/";
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+path;
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}


// WEBPACK FOOTER //
// ./src/assets/js/scripts.js